import {
  LEARN_LIBRARY_ONE_TIME_GBP,
  LEARN_SUBSCRIPTION_PRICE_GBP_YEAR,
} from '../../config/subscription'

/** Replace {{annual}} and {{once}} in marketing copy with the published library prices. */
export function applyCatalogueFacts(text: string): string {
  return text
    .replaceAll('{{annual}}', String(LEARN_SUBSCRIPTION_PRICE_GBP_YEAR))
    .replaceAll('{{once}}', LEARN_LIBRARY_ONE_TIME_GBP.toFixed(2))
}
